<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>icons / 24x24 / history</title>
    <g
      id="icons-/-24x24-/-history"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <g
        id="file-text"
        transform="translate(4.000000, 2.000000)"
        stroke="#97ABBE"
        stroke-width="2"
      >
        <path
          d="M10,0 L2,0 C0.8954305,0 0,0.8954305 0,2 L0,18 C0,19.1045695 0.8954305,20 2,20 L14,20 C15.1045695,20 16,19.1045695 16,18 L16,6 L10,0 Z"
          id="Path"
        ></path>
        <polyline id="Path" points="10 0 10 6 16 6"></polyline>
        <line x1="12" y1="11" x2="4" y2="11" id="Path"></line>
        <line x1="12" y1="15" x2="4" y2="15" id="Path"></line>
        <polyline id="Path" points="6 7 5 7 4 7"></polyline>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "icon"
};
</script>